import axios from "../index"

/**
 * 书籍详情
 * GET
 * bookId 	书籍ID
 * @returns {*}
 */
 export function getBookById(params) {
    return axios.get('/portal/book/getBookById', {params})
}

/**
 * 新增阅读记录
 * @param params
 * @returns {*}
 */
 export function addReadHistory(params) {
  return axios.post('/portal/history/addReadHistory', params)
}

/**
 * 主从目录查询接口
 * @param params
 * @returns {*}
 */
 export function getMasterSlaveCatalogue(params) {
  return axios.get('/portal/book/getMasterSlaveCatalogue', {params})
}

/**
 * 浏览量 热门推荐
 * @param params
 * @returns {*}
 */
 export function getHistoryOrder(params) {
    return axios.get('/portal/history/getHistoryOrder', {params})
}

/**
 * 收藏
 * @param params
 * @returns {*}
 */
 export function addCollection(params) {
   return axios.post('/portal/collection/addCollection', params)
 }

/**
 * 取消收藏
 * @param params
 * @returns {*}
 */
 export function deleteCollectionById(params) {
  return axios.post('/portal/collection/deleteCollectionById', params)
}



/**
 * 收藏是否存在
 * @param params
 * @returns {*}
 */
 export function getBookStatusByBookId(params) {
    return axios.get('/portal/collection/getBookStatusByBookId', {params})
  }

